import {Injectable} from "@angular/core";
import Swal from 'sweetalert2'
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})

export class SweetAlertService {

  constructor(private router: Router) {}

  static swalError(res) {
    this.customSwal(res.error.message, `Error HTTP ${res.status}`, 'error', res.status);
  }

  static swalSuccess(res) {
    this.customSwal('', `Success`, 'success', res.status);
  }

  static swalSuccessDraft(res) {
    this.customSwal('Your draft has been saved successfully', `Success`, 'success', res.status);
  }

  static swalSuccessCustom(text: string, title: string) {
    this.customSwal(text, title, 'success', 200);
  }

  // THIS FOR Single Approval
  static customSwal(text, title, icon = 'error', status) {
    if (status == 401) {
      Swal.fire({
        icon: icon === 'error' ? 'error' : (icon === 'warning' ? 'warning' : 'success'),
        confirmButtonColor: '#3699FF',
        title: 'Session Expired',
        text: 'Your session has timeout, please sign in again'
      }).then((result) => {
        window.location.href="/#logout=true"
      });
    } else if (status == 502) {
      const titleStr = '';
      const textStr = 'Our system is currently under maintenance. We will get back soon to serve you better';
      Swal.fire({
        icon: 'warning',
        confirmButtonColor: '#3699FF',
        title: titleStr,
        text: textStr
      }).then();
    } else if (status == 503 || status === 0) {
      const titleStr = '';
      const textStr = 'Your submission is unsuccessful. Please try again in a few minutes';
      Swal.fire({
        icon: 'warning',
        confirmButtonColor: '#3699FF',
        title: titleStr,
        text: textStr
      }).then();
    } else {
      Swal.fire({
        icon: icon === 'error' ? 'error' : (icon === 'warning' ? 'warning' : 'success'),
        confirmButtonColor: '#3699FF',
        title,
        text
      }).then();
    }
  }

  // THIS FOR Single Approval
  static swalErrorNoApi(title: string, text: string) {
    Swal.fire({
      icon: 'error',
      confirmButtonColor: '#3699FF',
      title,
      text
    }).then();
  }

  // THIS FOR Single Approval
  static swalErrorNoApiHtml(title: string, arr = []) {
    let html = '<ul>';
    arr.forEach((el) => {
      html = html + '<li>' + el + '</li>';
    })
    html = html + '</ul>';
    Swal.fire({
      icon: 'error',
      confirmButtonColor: '#3699FF',
      title,
      html: html
    }).then();
  }

  // THIS FOR Single Approval
  static swalWithUrl(title: string, showDeny: boolean, showCancel: boolean, textConfirm: string, textDeny: string, icon, urlConfirmed: string, textDenied: string) {
    Swal.fire({
      title,
      icon,
      showDenyButton: showDeny,
      showCancelButton: showCancel,
      confirmButtonText: textConfirm,
      denyButtonText: textDeny,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        window.location.href = urlConfirmed;
      } else if (result.isDenied) {
        Swal.fire(textDenied, '', 'info')
      }
    })
  }

  // THIS FOR Single Approval
  static idleLogout() {
    Swal.fire({
      icon: 'error',
      confirmButtonColor: '#3699FF',
      title: 'Session Expired',
      text: 'Your session has timeout, please sign in again'
    }).then((result) => {
      window.location.href="/auth/login"
    });
  }

}
